// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CampaignMappingFieldPagingResultModel from '../../model/campaign-mapping-field-paging-result-model';
import CampaignMappingFieldPagingResultDTO from '../dto/campaign-mapping-field-paging-result-dto';
import dtoSchema from '../schemas/campaign-mapping-field-paging-result-schema';
import CampaignMappingFieldModel from '../../model/campaign-mapping-field-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class CampaignMappingFieldPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CampaignMappingFieldPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => CampaignMappingFieldModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: CampaignMappingFieldModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<CampaignMappingFieldPagingResultDTO>): CampaignMappingFieldPagingResultModel;
  static toModel(dto: DeepPartial<CampaignMappingFieldPagingResultDTO> | undefined | null): CampaignMappingFieldPagingResultModel | undefined;
  static toModel(dto: DeepPartial<CampaignMappingFieldPagingResultDTO> | undefined | null): CampaignMappingFieldPagingResultModel | undefined {
    return dto ? new CampaignMappingFieldPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CampaignMappingFieldPagingResultModel> | CampaignMappingFieldPagingResultModel): CampaignMappingFieldPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as CampaignMappingFieldPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CampaignMappingFieldPagingResultModel, can not map to CampaignMappingFieldPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
